import { combineReducers, Reducer, ReducersMapObject } from 'redux';
import unifiedGroupListViewStateReducer from './unifiedGroupListViewStateReducer';
import type { GroupsState } from '../../../state/groupsState';
import hubInitStateReducer from './hubInitStateReducer';
import leaveGroupDialogStateReducer from './leaveGroupDialogStateReducer';
import exportGroupDialogStateReducer from './exportGroupDialogStateReducer';

const reducer: Reducer<GroupsState> = combineReducers<GroupsState>({
    unifiedGroupListViewState: unifiedGroupListViewStateReducer,
    hubInitialized: hubInitStateReducer,
    showLeaveGroupDialog: leaveGroupDialogStateReducer,
    showExportGroupDialog: exportGroupDialogStateReducer,
} as ReducersMapObject<GroupsState>);

export default reducer;
